import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Prevent clicking those buttons accidentally
    this.element.addEventListener("click", function(event) {
      var el = event.target;
      if (el.tagName === "BUTTON") {
        event.preventDefault();
      }
    }, true);
  }
}
